import React from "react";

const RequestComment = () => {
  let data = [
    {
      id: 0,
      name: "User Name",
      description:
        "We supply a series of design principles, practical patterns and high quality design resources (Sketch and Axure), to help people create their product prototypes beautifully and efficiently.",
      time: "1",
    },
    {
      id: 1,
      name: "Ali Omar",
      description:
        "We supply a series of design principles, practical patterns and high quality design resources (Sketch and Axure), to help people create their product prototypes beautifully and efficiently.",
      time: "8",
    },
    {
      id: 2,
      name: "Tarek Gamal",
      description:
        "We supply a series of design principles, practical patterns and high quality design resources (Sketch and Axure), to help people create their product prototypes beautifully and efficiently.",
      time: "11",
    },
  ];

  return (
    <div className="workorders-content workorders-content-comments ">
      <div className="work-orders-comments">
        <div className="position-relative">
          <textarea className="form-control"></textarea>
          <img
            src={`${process.env.PUBLIC_URL}/assets/RoundSend.svg`}
            alt="send"
          />
        </div>
        <div className="hint flex-between">
          <div>Don't diclose personal info</div>
          <div>0/232</div>
        </div>
      </div>
      <div className="p-8">
        {data?.map((i) => (
          <div key={i.id} className="w-100 border-bottom mt-2">
            <div className="comments-container">
              <div className="comments-username-slug">
                <p>{i.name[0]}</p>
              </div>
              <div className="w-100">
                <div className="d-flex align-items-center">
                  <div className="comments-username me-2">{i.name}</div>
                  <span className="comments-username-time">
                    {i.time} day ago
                  </span>
                </div>
                <div className="mb-2">{i.description}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RequestComment;
